



























import { Component, Vue } from "vue-property-decorator";
import { EventBus } from "@/EventBus";

@Component
export default class SyncIndicator extends Vue {

    get syncing() {
        return this.actions.length > 0;
    }

    private actions: any[] = [];

    private failedMessage = '';
    private failedSnackbar = false;
    private timeoutFunction: null | NodeJS.Timeout = null;

    mounted() {
        EventBus.$on('processing-snackbar', (data: any) => {
            this.actions.push(true)
            if (this.timeoutFunction) {
                clearTimeout(this.timeoutFunction)
            }
            this.timeoutFunction = setTimeout(() => this.timeoutFail(), 30000);
        });

        EventBus.$on('complete-snackbar', (data: any) => {
            this.actions.shift()
            if (this.actions.length === 0 && this.timeoutFunction) {
                clearTimeout(this.timeoutFunction)
            }
        });

        EventBus.$on('failed-snackbar', (data: any) => {
            this.actions.shift()
            this.failedSnackbar = true;
            this.failedMessage = data.message;
        });
    }

    timeoutFail() {
        this.failedMessage = `Timeout or failure occurred for ${this.actions.length} calls`
        this.failedSnackbar = true;
        this.actions = [];
    }
}
